// src/publish/pieces/instagramPost.js — pieces of the Instagram post (format key 'instagram-post').
//
// Same backend fields as the LinkedIn post plus cta_url. Instagram has one box
// (the caption) and no clickable link in it, hence:
//   caption   primary, kind 'plain', limit LIMITS.instagramCaption (2200, 125
//             visible before «altro») — hook + body + cta + the hashtag line
//             (the backend puts the hashtags inside the caption by choice)
//   hook      kind 'plain', the first lines the feed shows — a copy of the
//             caption's opening, offered on its own for the operator's check
//   hashtags  kind 'tags', only when the backend sent any
//   link      kind 'url', label «Link in bio»: the brief's cta_url
//             (content.cta_url else params.cta_url), only when there is one
// A title, when present, is never part of the caption.
// Labels / destinations: outputs:pieces.labels.instagram-post.* and
// outputs:pieces.destinations.instagram-post.* (see ../piece.js header).

import { normalizeText } from '../normalize.js';
import { makePiece, ctaUrlOf, tagsBlocks, urlBlocks, ensureOnePrimary, str, LIMITS } from '../piece.js';
import { socialPostBlocks } from './linkedinPost.js';

const FORMAT = 'instagram-post';

export function build(entry) {
  const content = entry?.results?.content;
  if (!content || typeof content !== 'object') return [];
  const pieces = [];

  const caption = socialPostBlocks(content);
  if (caption.length) pieces.push(makePiece(FORMAT, { id: 'caption', primary: true, blocks: caption, limit: LIMITS.instagramCaption }));

  const hook = normalizeText(str(content.hook));
  if (hook.length) pieces.push(makePiece(FORMAT, { id: 'hook', blocks: hook }));

  const tags = tagsBlocks(content.hashtags);
  if (tags.length) pieces.push(makePiece(FORMAT, { id: 'hashtags', kind: 'tags', blocks: tags }));

  const url = urlBlocks(ctaUrlOf(entry));
  if (url.length) pieces.push(makePiece(FORMAT, { id: 'link', kind: 'url', blocks: url }));

  return ensureOnePrimary(pieces);
}
